<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body work-hours-page">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h3>Work Hours</h3>
                            <!-- Select-Box для выбора недели -->
                            <select-box
                                :items="weeks"
                                :item-label="week => week.label"
                                :item-value="week => week.number"
                                :selected-value="selectedWeek"
                                wrapper-class="mb-3 col-sm-6"
                                @update:selectedValue="handleWeekChange"
                                placeholder="Select a week"
                            />
                        </div>
                        <!-- Таблица с данными -->
                        <div class="dt-ext table-responsive">
                            <table id="show-hidden-row" class="display table">
                                <thead>
                                <tr>
                                    <th>User</th>
                                    <th v-for="(day, index) in displayedWeekDays" :key="index">
                                        <!-- Упрощенный шаблон, кастомизация через headerCallback -->
                                    </th>
                                    <th>Total</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <!-- DataTables будет управлять содержимым -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <basic-modal title="User Weekly Summary" target-id="user-summary-modal" set-class="modal-lg">
            <template v-slot:modal_body>
                <summary-block
                    v-if="summaryData"
                    :summaryData="summaryData"
                    :isEditableWeek="isEditableWeek"
                />
                <p v-else>Загрузка данных...</p>
            </template>
        </basic-modal>
    </div>
</template>

<script>
import axios from "axios";
import SelectBox from '../Basic/Forms/SelectBox.vue';
import SummaryBlock from "../WorkCalendar/SummaryBlock.vue";
import BasicModal from "../Basic/BasicModal.vue";

export default {
    name: "WorkHours",
    components: {
        BasicModal,
        SummaryBlock,
        SelectBox,
    },
    data() {
        return {
            selectedWeek: null,
            weeks: this.generateWeeks(),
            weekDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            users: [],
            summaryData: null,
        };
    },
    computed: {
        displayedWeekDays() {
            return this.weekDays.filter(day => day !== "Sunday");
        },
    },
    created() {
        this.selectedWeek = this.getCurrentWeekNumber();

        console.log('created:getCurrentWeekNumber', this.getCurrentWeekNumber());

        this.fetchWorkHours();
    },
    methods: {
        isEditableWeek(week) {
            return false;
        },
        generateWeeks() {
            const weeks = [];
            const currentWeek = this.getCurrentWeekNumber();
            const today = new Date();

            for (let i = 0; i < 6; i++) {
                if (currentWeek - i > 0) {
                    const weekNumber = currentWeek - i;
                    const dateRange = this.getWeekDateRange(weekNumber, today.getFullYear());
                    weeks.push({
                        number: weekNumber,
                        label: `Week ${weekNumber}, ${dateRange.start} - ${dateRange.end}`, // Текст для отображения
                    });
                }
            }

            return weeks;
        },

        getCurrentWeekNumber() {
            const today = new Date();

            const firstMonday = new Date(today.getFullYear(), 0, 4);
            const diffToMonday = (firstMonday.getDay() + 6) % 7;
            firstMonday.setDate(firstMonday.getDate() - diffToMonday);

            const diff = today - firstMonday;
            const oneWeek = 7 * 24 * 60 * 60 * 1000;

            return Math.ceil(diff / oneWeek);
        },

        getWeekDateRange(weekNumber, year) {
            const firstDayOfYear = new Date(year, 0, 1);
            const daysOffset = (weekNumber - 1) * 7;
            const weekStart = new Date(firstDayOfYear.getTime() + daysOffset * 24 * 60 * 60 * 1000);

            const diffToMonday = weekStart.getDay() === 0 ? -6 : 1 - weekStart.getDay();
            weekStart.setDate(weekStart.getDate() + diffToMonday);

            const weekEnd = new Date(weekStart);
            weekEnd.setDate(weekStart.getDate() + 6);

            return {
                startRaw: weekStart,
                start: this.formatDate(weekStart), // Row: `Jan 20`
                end: this.formatDate(weekEnd),     // Row: `Jan 26`
            };
        },

        formatDate(date) {
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const day = date.getDate();
            const month = monthNames[date.getMonth()];
            return `${month} ${day < 10 ? `0${day}` : day}`;
        },

        handleWeekChange(value) {
            this.selectedWeek = value;
            this.fetchWorkHours(); // Загружаем данные для выбранной недели
        },

        fetchWorkHours() {
            axios
                .get("/api/entries/work-hours", { params: { week: this.selectedWeek } })
                .then((response) => {
                    this.users = response.data;
                    this.$nextTick(() => {
                        this.initializeDataTable();
                    });
                })
                .catch((error) => {
                    console.error("Error fetching work hours:", error);
                });
        },

        initializeDataTable() {
            const tableId = "#show-hidden-row";

            if ($.fn.dataTable.isDataTable(tableId)) {
                $(tableId).DataTable().clear().destroy();
            }

            const table = $(tableId).DataTable({
                data: this.users,
                responsive: {
                    details: {
                        display: $.fn.dataTable.Responsive.display.childRowImmediate,
                        type: "",
                    },
                },
                autoWidth: false,
                dom: "lBtip",
                buttons: [],
                order: [[0, "asc"]],
                columns: [
                    { data: "user_name", title: "User" },
                    ...this.displayedWeekDays.map((day) => ({
                        data: `daily_hours.${day}`,
                        title: day,
                        defaultContent: "-",
                    })),
                    { data: "total_weekly_time", title: "Total" },
                    {
                        data: null,
                        title: "Action",
                        orderable: false,
                        render: (data, type, row) => {
                            return `
                        <button class="btn btn-sm btn-info action-detail" data-id="${row.user_id}">
                            Detail
                        </button>`;
                        },
                    },
                ],
                headerCallback: (thead) => {
                    const headerDays = this.getDatesOfWeek(); // Получаем данные дней недели (название и даты)
                    const ths = $(thead).find("th").toArray();

                    headerDays.forEach((day, index) => {
                        const th = ths[index + 1]; // Новая дата для текущей недели
                        $(th).html(`
                            <span class="datatable-header-text">${day.dayName}</span>
                            <br />
                            <small>(${day.date})</small>
                         `);
                    });
                },
                drawCallback: () => {
                    this.attachDetailButtonHandler(); // Привязываем обработку кнопок в таблице
                },
            });

            this.addDataTitles();
        },

        attachDetailButtonHandler() {
            const tableId = "#show-hidden-row";

            // Освобождаем обработчики, чтобы избежать дублирования
            $(tableId).off('click', '.action-detail');

            // Привязываем новый обработчик к кнопке
            $(tableId).on('click', '.action-detail', (event) => {
                event.preventDefault();

                const button = $(event.currentTarget);
                const userId = button.data('id'); // Получаем ID из data-id кнопки

                if (userId) {
                    this.openUserSummary(userId); // Открываем детальную информацию по пользователю
                } else {
                    console.error('Кнопка не содержит ID пользователя.');
                }
            });
        },

        openUserSummary(userId) {
            axios
                .get(`/api/entries/weekly-times`, {
                    params: {
                        week: this.selectedWeek,
                        user_id: userId,
                    },
                })
                .then((response) => {
                    this.summaryData = response.data; // Сохраняем данные для передачи в модальное окно

                    $('#user-summary-modal').modal('show'); // Открываем модальное окно
                })
                .catch((error) => {
                    console.error('Ошибка при загрузке данных пользователя:', error);
                    alert('Не удалось загрузить данные.');
                });
        },

        addDataTitles() {
            const headers = [];
            $("#show-hidden-row thead th").each(function () {
                headers.push($(this).text());
            });

            $("#show-hidden-row tbody tr").each(function () {
                $(this)
                    .children("td")
                    .each(function (index) {
                        $(this).attr("data-title", headers[index]);
                    });
            });
        },

        getDatesOfWeek() {
            const currentWeekRange = this.getWeekDateRange(this.selectedWeek, new Date().getFullYear());
            const startDate = new Date(currentWeekRange.startRaw); // Конвертируем дату начала (start) к объекту Date
            const dates = [];

            for (let i = 0; i < 6; i++) {
                const day = new Date(startDate); // Копируем текущую дату
                day.setDate(startDate.getDate() + i); // Добавляем дни

                dates.push({
                    dayName: this.displayedWeekDays[i], // Название дня ("Monday", "Tuesday", и т.д.)
                    date: this.formatDate(day), // Форматируем итоговую дату, например: (Jan 20)
                });
            }

            return dates;
        },
    },
};
</script>

<style scoped>

table {
    &.dataTable {
        &.table {
            text-align: center;

            thead {
                background-color: #f5f5f5;

                th {
                    position: relative;
                    vertical-align: middle;
                    text-align: center;
                    white-space: nowrap;

                    padding-right: 2rem;

                    .sorting,
                    .sorting_asc,
                    .sorting_desc {
                        display: inline-block;
                        text-align: center;
                        vertical-align: middle;
                        padding-right: 30px;

                        &::before,
                        &::after {
                            position: absolute;
                            right: 0.5rem;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }

                    .datatable-header-text {
                        display: inline-block;
                        margin-right: 8px;
                    }
                }
            }

            tbody {
                td {
                    vertical-align: middle;
                }
            }
        }
    }
}

.dt-ext {
    &.table-responsive {
        overflow-x: inherit;
    }
}
</style>
